// App-wide render-crash fallback. Sentry.ErrorBoundary reports the error; this
// keeps the app from white-screening and lets the user recover with a reload.
import { useTranslation } from "react-i18next"

function AppCrashFallback() {
  const { t } = useTranslation("errors")
  return (
    <div className="min-h-screen flex items-center justify-center bg-landing-gradient px-6">
      <div className="max-w-md text-center border bg-white rounded-2xl px-8 py-12 shadow-lg">
        <h2 className="text-2xl font-bold text-main-purple mb-3">
          {t("crash.title")}
        </h2>
        <p className="text-my-black/80 mb-6">
          {t("crash.message")}
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-xl bg-main-purple px-6 py-3 font-semibold text-white"
        >
          {t("crash.reload")}
        </button>
      </div>
    </div>
  )
}

export default AppCrashFallback
